<template>
  <aside class="cta-modal" :data-active="isVisible">
    <div>
      <h2 v-if="content.title" class="cta-modal__title">{{ content.title }}</h2>
      <p v-if="content.description">{{ content.description }}</p>
      <a v-if="content.link" :href="content.link.url" :target="content.link.target" class="button cta-modal__link">{{
        content.link.title
      }}</a>
    </div>
    <button class="cta-modal__button" @click="isVisible = false">
      <Icon id="more" />
    </button>
  </aside>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'CTAModal',
  components: { Icon },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.isVisible = true
    }, 1000)
  }
}
</script>
